import React from 'react';
import { useEasterEgg } from '../../hooks/useEasterEgg';
import { useSecretTestingEasterEgg } from '../../hooks/useSecretTestingEasterEgg';
import SecretTestRunner from '../testing/SecretTestRunner';

const EasterEggDetector: React.FC = () => {
  useEasterEgg();
  const { isModalOpen, setIsModalOpen } = useSecretTestingEasterEgg();
  
  return (
    <>
      <SecretTestRunner 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)} 
      />
    </>
  );
};

export default EasterEggDetector;